import { DateUtils } from "./DateUtils";

// Legacy exports - use DateUtils directly for new code
export const formatDateToMonthYear = (
  dateInput: string | Date | null | undefined
): string => {
  return DateUtils.toMonthYear(dateInput);
};

export const formatDate = (input: Date | string | null | undefined): string => {
  return DateUtils.toISO(input) || "";
};

export const formatDateToString = (
  input: Date | string | null | undefined
): string => {
  return DateUtils.toLocalizedString(input);
};

export const convertSpecialDateFormat = (dateString: string): string => {
  const isoDate = DateUtils.toISO(dateString);
  if (isoDate) {
    const date = new Date(isoDate);
    return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
  }
  return dateString;
};
